import React from 'react';
import FAQ from '@/src/components/faq/FAQ';

export const FaqSectionPage: React.FC = () => {
  return <FAQ />;
};
